<template>
  <div class="digifarm-logo" :class="{ minimized }">
    <router-link to="/dashboard">
      <img src="@/assets/digifarm-logo.png" alt="digifarm-logo">
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      minimized: 'sidebar/minimized',
    }),
  }
}
</script>

<style lang="scss" scoped>

.digifarm-logo {
  padding: 10px 20px;
  transition: 0.3s ease padding;

  display: flex;
  align-items: center;
  // justify-content: center;
  border-bottom: 1px solid #E4E5E6;

  img {
    width: 100%;
    height: auto;

    max-width: 120px;
  }

  &.minimized {
    padding: 5px 10px;
  }
}

</style>